import BannerTemplate from '../DefaultBanner/index'
import App from "../../../App";
import { reportPV, reportImpressions, reportOfferImpression } from '@src/common/report'
import { device, getMousePosition, getParams2Native, replaceAppFlyerHost, setClickUrl, setNoticeUrl, checkAndroidSDKVersion } from '@src/common/util'

import { report } from '@src/common/decorators'
import { onScreenClick } from '@src/common/report'

export default class DefaultBannerFix extends BannerTemplate {
    constructor(props) {
        super(props)
        //this.campaign = props.campaign || {}
    }
    @report([{
        proxySelector: '.jumpUrl',
        targetSelector: '.jumpUrl',
        eventName: 'click',
        action: onScreenClick
    }])
    adShowed(res) {
        console.log('fix banner showed')
        this.windowStartPoint = res&&res.param || {};
    }
}